<template>
  <teleport v-if="widget && loaded" :to="'#' + teleport">
    <div class="orm-background--cta1">
      <div class="orm-container">
        <div class="orm-row">
          <div class="orm-col-xs-12">
            <div class="orm-row">
              <div class="orm-carfilter__element orm-col-xs-12 orm-col-sm-12">
                <filterSelect
                  v-if="selectedGroup"
                  :groupFilter="groupFilter"
                  :preselect="selectedGroup"
                  @update:dataPool="updateFilter"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="orm-row">
          <div class="orm-col-xs-12">
            <div class="orm-row" v-if="carGroup.length > 0 && stations">
              <Car
                v-for="car in carGroup"
                :key="car.id"
                :data="car"
                :stations="filterCarStations(car)"
                :filter="showCar(car.vehicle_category)"
                :vehicles-list="true"
                :small="smallview"
                :opened="opendCar"
                @update:openedCar="opendCar = $event"
              />
            </div>
            <div
              v-if="carGroup.length == 0"
              style="height: 400px"
              class="orm-row orm-pb-60 center-xs"
            >
              <div class="orm-preload-page">
                <i class="fa fa-spinner-third orm-rotate360"></i>
              </div>
            </div>
          </div>
        </div>
      </div></div
  ></teleport>
</template>
<script>
import store from "@/store";

import Car from "@/components/cargroup/car.vue";
import filterSelect from "@/components/ui/filter-select.vue";

import { slugMe } from "@/constants/formater";

export default {
  components: { Car, filterSelect },
  props: ["name"],
  data() {
    return {
      carGroup: [],
      groupFilter: [],
      selectedAll: true,
      selectedGroup: false,
      carcategory: [],
      stations: null,
      opendCar: null,
      loaded: false,
    };
  },
  setup() {
    const teleport = "crentVehicleslist";
    let widget = false;
    const myEle = document.getElementById(teleport);
    let smallview = false;
    if (myEle !== null) {
      widget = true;
      if (myEle.dataset) {
        if (myEle.dataset.smallview) {
          smallview = myEle.dataset.smallview === "true" ? true : false;
        }
      }
    }
    return { teleport, widget, smallview };
  },
  async mounted() {
    await store.dispatch("cargroup/SET_CARGROUPS_ALL");
    this.init();
    this.loaded = true;
  },
  methods: {
    async init() {
      const page = document.getElementById("crentReservation");

      const sttype = page.dataset.stationtype;

      const stationsFilter = await store.getters[
        "stations/GET_STATIONS_FILTERED"
      ];
      this.stations = stationsFilter[sttype];

      const carGroup = await store.getters["cargroup/GET_GLOBAL_CARGROUPS"];
      const carcategoryids = [];

      carGroup.forEach((element) => {
        element["vehicle_category"].forEach(() => {
          const enabled = element.enabled_stations;
          for (const key in enabled) {
            if (Object.hasOwnProperty.call(enabled, key)) {
              const enabledkey = enabled[key];
              const check = stationsFilter[sttype].find(
                (x) => x.id == enabledkey
              );

              if (check) {
                const vehiclecategory = element.vehicle_category;
                for (const key in vehiclecategory) {
                  carcategoryids.indexOf(vehiclecategory[key].id) === -1
                    ? carcategoryids.push(vehiclecategory[key].id)
                    : false;
                }
                const newElement = JSON.parse(JSON.stringify(element));
                const enabledfilteredstations = [];
                for (const station in stationsFilter[sttype]) {
                  // const element = station[key];
                  if (
                    newElement["enabled_stations"].find(
                      (x) => x === stationsFilter[sttype][station].id
                    )
                  ) {
                    enabledfilteredstations.push(
                      stationsFilter[sttype][station].id
                    );
                  }
                }
                newElement["enabled_stations"] = enabledfilteredstations;
                if (!this.carcategory.find((x) => x.id === newElement.id)) {
                  this.carcategory.push(newElement);
                }

                return;
              }
            }
          }
        });
      });
      this.carGroup = this.carcategory;

      // this.groupFilter = await store.getters["cargroup/GET_GLOBAL_GROUPFILTER"];
      this.groupFilter = carcategoryids;
      let selectedcarcategory = null;
      if (document.getElementById("crentVehicleslist")) {
        selectedcarcategory = document.getElementById("crentVehicleslist")
          .dataset.category;
      }

      if (selectedcarcategory) {
        this.selectedGroup = {};
        const kfzcategories = selectedcarcategory.split("+");
        if (kfzcategories.length > 1) {
          for (const key in kfzcategories) {
            if (Object.hasOwnProperty.call(kfzcategories, key)) {
              const kfzcategory = kfzcategories[key];
              if (
                this.groupFilter.find(
                  (element) => slugMe(element) == kfzcategory
                )
              ) {
                this.selectedGroup[
                  this.groupFilter.find(
                    (element) => slugMe(element) == kfzcategory
                  )
                ] = true;
              }
            }
          }
          store.dispatch("userSession/SET_CARCATEGORY", this.selectedGroup);
          this.selectedAll = false;
          // this.selectwait = false;
        } else if (
          this.groupFilter.find(
            (element) => slugMe(element) == selectedcarcategory
          )
        ) {
          this.selectedGroup[
            this.groupFilter.find(
              (element) => slugMe(element) == selectedcarcategory
            )
          ] = true;
          store.dispatch("userSession/SET_CARCATEGORY", this.selectedGroup);
          this.selectedAll = false;
          // this.selectwait = false;
        }
      } else {
        this.selectedGroup = await store.getters["userSession/GET_CARCATEGORY"];
        if (Object.keys(this.selectedGroup).length) {
          this.selectedAll = false;
        }
        // this.selectwait = false;
      }
    },
    showCar(group) {
      let hasfilter = false;
      if (group.length == 0 && this.selectedAll) return true;
      group.forEach((element) => {
        if (this.selectedGroup[element.id] || this.selectedAll) {
          hasfilter = true;
          return true;
        }
      });
      return hasfilter;
    },
    updateFilter(ev) {
      this.selectedGroup = ev.selectedGroup;
      this.selectedAll = ev.selectedAll;
    },
    search(nameKey, myArray) {
      for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].category === nameKey) {
          return myArray[i];
        }
      }
    },
    filterCarStations(car) {
      const filteredStations = [];
      for (const station in this.stations) {
        if (
          car["enabled_stations"].find(
            (x) => x === this.stations[station]["id"]
          )
        ) {
          filteredStations.push(this.stations[station]);
        }
      }
      return filteredStations;
    },
  },
};
</script>
